module.exports = __webpack_public_path__ + "static/media/Tampa_Bay_Rays.82cee357.svg";